import * as React from 'react';
import { ChatIneligibleCopy } from 'constants/CopyConstants';
import Coin from 'components/Coin';
import LayerTrigger from 'components/LayerTrigger';
import Tooltip from 'components/Tooltip';
import Glyph from 'components/Glyph';
import { GlyphName } from '@remind/r101-glyphs';
import { CoinColor } from 'components/Coin';

import { ContactabilityStatus } from 'globalTypes';

export const contactabilityStyles = {
  rich: {
    backgroundColor: 'mascot',
    iconName: 'lightning-bolt',
    copy: 'Reachable',
  },
  poor: {
    backgroundColor: 'percussion',
    iconName: 'ellipses',
    copy: 'Needs a mobile number',
  },
  uncontactable: {
    backgroundColor: 'percussion',
    iconName: 'lock-nokey',
    copy: ChatIneligibleCopy.INELIGIBLE,
  },
  ghost: {
    backgroundColor: 'percussion',
    iconName: 'close',
    copy: 'No contact point',
  },
};

type Props = {
  status: ContactabilityStatus;
};

function ContactabilityBadge(props: Props) {
  const { status } = props;
  const styles = contactabilityStyles[status] || {};

  return (
    <Coin color={styles.backgroundColor as CoinColor} size="xsmall">
      <LayerTrigger layer={<Tooltip>{styles.copy}</Tooltip>} placement="top">
        <Glyph name={styles.iconName as GlyphName} color="whiteout" solo />
      </LayerTrigger>
    </Coin>
  );
}

export default ContactabilityBadge;
